import { GeneralProperties } from "./general-properties";
import  WidgetSettings  from "./widget-settings";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";
import { UserDefaults } from "./user-defaults";
import { ObjectLabels } from "./object-labels";

export const validateForm = (subDepartment, setErrors, setSelectedValue) => {
  const newErrors = {
    Name: !subDepartment.Name.trim(),
    'ObjectLabels.ProjectSingular': !subDepartment.ObjectLabels?.ProjectSingular?.trim(),
    'ObjectLabels.ProjectPlural': !subDepartment.ObjectLabels?.ProjectPlural?.trim(),
    'ObjectLabels.ProjectSingularPossessive': !subDepartment.ObjectLabels?.ProjectSingularPossessive?.trim(),
    'ObjectLabels.ProjectPluralPossessive': !subDepartment.ObjectLabels?.ProjectPluralPossessive?.trim(),
    'ObjectLabels.TaskSingular': !subDepartment.ObjectLabels?.TaskSingular?.trim(),
    'ObjectLabels.TaskPlural': !subDepartment.ObjectLabels?.TaskPlural?.trim(),
    'ObjectLabels.TaskSingularPossessive': !subDepartment.ObjectLabels?.TaskSingularPossessive?.trim(),
    'ObjectLabels.TaskPluralPossessive': !subDepartment.ObjectLabels?.TaskPluralPossessive?.trim(),
    'ObjectLabels.FormSingular': !subDepartment.ObjectLabels?.FormSingular?.trim(),
    'ObjectLabels.FormPlural': !subDepartment.ObjectLabels?.FormPlural?.trim(),
    'ObjectLabels.FormSingularPossessive': !subDepartment.ObjectLabels?.FormSingularPossessive?.trim(),
    'ObjectLabels.FormPluralPossessive': !subDepartment.ObjectLabels?.FormPluralPossessive?.trim(),
  };
  setErrors(newErrors);

 if (newErrors.Name) {
    setSelectedValue("General");
  } else if (Object.values(newErrors).some((field) => field === true)) {
    setSelectedValue("Labels");
  }
  return Object.values(newErrors).every((field) => field === false);
};

export const PrepareBreadCrumbList = (subdepartment, selectedValue) => {
  return [
    { Href: "/admin", Text: "Admin" },
    { Href: "/admin?tab=organization", Text: "Organization" },
    { Href: "/admin?tab=organization&subtab=subdepartments", Text: "Sub-Departments" },
    {
      Href: null,
      Text:
        subdepartment.Name === ""
          ? "Untitled Sub-Department"
          : subdepartment.Name,
    },
    { Href: null, Text: SelectedTab(selectedValue) },
  ];
};

export const tabList = [
  {
    Label: "General Properties",
    Icon: (
      <FluentUiIcon name={"WindowTextBundle"} color={"#212121"} size={18} />
    ),
    Id: "General",
  },
  {
    Label: "User Defaults",
    Icon: (
      <FluentUiIcon name={"PersonSettingsRegular"} color={"#212121"} size={18} />
    ),
    Id: "User",
  },  
  {
    Label: "Object Labels",
    Icon: (
      <FluentUiIcon name={"TagRegular"} color={"#212121"} size={18} />
    ),
    Id: "Labels",
  },
  {
    Label: "Widget Settings",
    Icon: (
      <FluentUiIcon name={"SettingsRegular"} color={"#212121"} size={18} />
    ),
    Id: "Widget",
  }
];

export const SelectedTab = (selectedValue) => {
  switch (selectedValue) {
    case "General":
      return "General Properties";
    case "User":
      return "User Defaults";
    case "Widget":
      return "Widget Settings";
    case "Labels":
      return "Object Labels";
    default:
      return "General Properties";
  }
};

export const SelectedTabContent = (
  selectedValue,
  subDepartment,
  setSubDepartment,
  errors,
  setErrors
) => {
  switch (selectedValue) {
    case "General":
      return (
        <GeneralProperties
          subDepartment={subDepartment}
          setSubDepartment={setSubDepartment}
          errors={errors}
          setErrors={setErrors}
        />
      );
    case "User":
      return (
        <UserDefaults
          subDepartment={subDepartment}
          setSubDepartment={setSubDepartment}
          errors={errors}
          setErrors={setErrors}
        />
      );
    case "Widget":
      return (
        <WidgetSettings
          subDepartment={subDepartment}
          setSubDepartment={setSubDepartment}
          errors={errors}
          setErrors={setErrors}
        />
      );
    case "Labels":
      return (
        <ObjectLabels
          subDepartment={subDepartment}
          setSubDepartment={setSubDepartment}
          errors={errors}
          setErrors={setErrors}
        />
      );
    default:
      return <div>General Properties</div>;
  }
};
